export const DEFAULT_COOKIE_CONSENT_OPTIONS = {
  functional: true,
  analytical: false,
  functionalsocial: false,
  marketing: false,
}
